
<div fxLayout="row"  >
    <div fxFlex="80%" class="fxLayout-unauthorized-container" >
      {{'Unauthorized_error_message' | translate}} <br><br> {{'Unauthorized_error_message_1' | translate}}
    </div>

</div>
